<script>
    export let hovered;
</script>

<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 14L0 14" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-miterlimit="10" stroke-linejoin="round"/>
    <path d="M1.64709 8.40414V1.64697H8.43822" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-miterlimit="10" stroke-linejoin="round"/>
    <path d="M8.43834 26.3529H1.64722V19.5957" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-miterlimit="10" stroke-linejoin="round"/>
    <path d="M19.5554 1.64697H26.3465V8.40414" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-miterlimit="10" stroke-linejoin="round"/>
    <path d="M26.3465 19.5957V26.3529H19.5554" stroke={hovered ? "#FE520A" : "white"} stroke-width="2.4" stroke-miterlimit="10" stroke-linejoin="round"/>
</svg>
